/* @generated */

// src/assets/ui-icon/line/hide.tsx
import * as React from "react";
var HideLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19.203 20.142 5.06 19.082 4l-2.697 2.696a7.809 7.809 0 0 0-4.054-1.135c-5.411 0-8.066 5.446-8.177 5.677L4 11.561l.154.322c.068.143 1.106 2.273 3.163 3.882l-2.378 2.377L6 19.202Zm2.398-4.52c-1.443-1.077-2.356-2.495-2.717-3.122.62-1.081 2.878-4.5 6.65-4.5 1.114 0 2.096.298 2.943.746L13.703 9.38a2.32 2.32 0 0 0-1.372-.318 2.321 2.321 0 0 0-2.5 2.5 2.321 2.321 0 0 0 .318 1.371l-1.751 1.752Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12.331 16.06a6.09 6.09 0 0 1-1.091-.097L10 17.203c.71.225 1.487.358 2.331.358 5.412 0 8.067-5.446 8.177-5.678l.154-.322-.154-.323c-.052-.109-.667-1.37-1.866-2.677l-1.07 1.07c.7.77 1.173 1.519 1.409 1.93-.622 1.081-2.88 4.5-6.65 4.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  HideLine
};
